/**
 * 주인 도메인이 없는 공용 모양. `Site` 는 `sites`, `FileResponse` 는 `files` 처럼
 * 경로가 있는 계약은 여기 넣지 않는다.
 */

/** 목록 조회 공통 쿼리 파라미터. */
export interface PageParams {
  page?: number;
  size?: number;
  sort?: string;
}

export interface PageResult<T> {
  content: T[];
  total: number;
}

export async function listAll<T>(
  fetchPage: (params: { page: number; size: number }) => Promise<PageResult<T>>,
  size = 200
): Promise<PageResult<T>> {
  const content: T[] = [];
  for (let page = 1; ; page++) {
    const result = await fetchPage({ page, size });
    content.push(...result.content);
    if (content.length >= result.total) return { content, total: result.total };
    if (result.content.length === 0) throw new Error("목록을 모두 불러오지 못했습니다.");
  }
}
